import React, { createContext, useContext } from "react";
import { CompetitionsResponse } from "../management-subscription/types";
import { SubscriptionCustomFeature } from "./interfaces";

export type ISubscriptionContext = {
  subscription: SubscriptionPlanUser;
  subsWillBeCancelled: boolean;

  botbCompetitions: CompetitionsResponse;
  setBotbCompetitions: React.Dispatch<React.SetStateAction<CompetitionsResponse>>;

  isCompetitionsLoading: boolean;
  setCompetitionsLoading: React.Dispatch<React.SetStateAction<boolean>>;

  activePricePlan: SubscriptionPriceUser;

  allPackages: Package[];

  isSubscriptionLoading: boolean;

  cancellationSubscriptionText: React.JSX.Element;
  subscriptionStatus: string;

  isBenefitsModalOpen: boolean;
  setIsBenefitsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;

  isRenewSubscriptionModalOpen: boolean;
  setIsRenewSubscriptionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;

  customSubscriptionFeatures: SubscriptionCustomFeature[];
  onRenewSubscription: () => void;

  isRenewButtonDisabled: boolean;

  totalEntries: string;
  description: React.JSX.Element;

  isInvoiceProcessing: boolean;
  setIsInvoiceProcessing: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SubscriptionCreatedContext = createContext<ISubscriptionContext>({
  activePricePlan: undefined,
  botbCompetitions: undefined,
  isCompetitionsLoading: false,
  setCompetitionsLoading: undefined,
  subsWillBeCancelled: false,
  subscription: undefined,
  setBotbCompetitions: undefined,
  allPackages: [],
  isSubscriptionLoading: false,
  cancellationSubscriptionText: null,
  subscriptionStatus: "",
  isBenefitsModalOpen: false,
  setIsBenefitsModalOpen: undefined,
  customSubscriptionFeatures: [],
  setIsRenewSubscriptionModalOpen: null,
  isRenewSubscriptionModalOpen: false,
  onRenewSubscription: undefined,
  isRenewButtonDisabled: false,
  totalEntries: "",
  description: null,
  isInvoiceProcessing: false,
  setIsInvoiceProcessing: null,
});

export const useSubscriptionContext = () => useContext(SubscriptionCreatedContext);
